import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import {
  ContentSection,
  InstructionStepper,
  Layout,
  Paragraph,
  SectionHeading,
  Icon,
} from '@vwfs-bronson/bronson-react'
import { connect } from 'react-redux'
import { Analytics } from '../../services/analytics'
import { setActualPage } from '../../services/redux/features/custom.redux'
import { pageName, trackPage, trackRedirectButton } from './tracking'
import { scrollToTop } from '../../services/common/form'
import CHI from '../../components/CHI'
import { isAudi } from '../../config'

export type ConfirmationPageProps = {
  setActualPage: Function
}

const ConfirmationPage: FunctionComponent<ConfirmationPageProps> = (props) => {
  const { t } = useTranslation()
  React.useEffect(() => {
    document.title = `${t('confirmation:tabTitle')}`
  }, [t])

  React.useEffect(() => {
    scrollToTop()
    props.setActualPage(pageName)
    Analytics.pageName = pageName
    setTimeout(() => {
      trackPage()
    }, 1000)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const handlePortal = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    window.location.href = t('confirmation:buttonPortal:link')
  }
  const handleRedirect = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    trackRedirectButton()
    window.location.href = t('confirmation:buttonRedirect:link')
  }
  return (
    <>
      <ContentSection pageWrap>
        <div className="u-text-center">
          <Icon
            aria-hidden="true"
            className="u-text-success"
            name="semantic-success"
          />
        </div>
        <SectionHeading level={1} center primary testId="confirmationHeading">
          {t('confirmation:heading')}
        </SectionHeading>
        <SectionHeading level={2} center testId="confirmationSubHeading">
          {t('confirmation:sub-heading-1')}
        </SectionHeading>
        <InstructionStepper statusActiveText="Status: Erledigt" statusNotActiveText="Status: Ausstehend">
          {t('confirmation:instructionStepper', { returnObjects: true }).map(
            (step: any) => (
              <InstructionStepper.Step icon={step.icon} title={step.title}>
                {step.text}
              </InstructionStepper.Step>
            )
          )}
        </InstructionStepper>
        <Paragraph testId="confirmationSubHeading2" className="u-mt">
          <strong>{t('confirmation:sub-heading-2')}</strong>
        </Paragraph>
        <Paragraph testId="confirmationText">{t('confirmation:text')}</Paragraph>
        <Layout center>
          <Paragraph>
            <Link to={t('confirmation:buttonPortal:link')} onClick={handlePortal}>
              {t('confirmation:buttonPortal:text')}
            </Link>
          </Paragraph>
        </Layout>
        <Layout center>
          <Paragraph>
            <Link
              to={t('confirmation:buttonRedirect:link')}
              onClick={handleRedirect}
            >
              {t('confirmation:buttonRedirect:text')}
            </Link>
          </Paragraph>
        </Layout>
      </ContentSection>
      {!isAudi() && <CHI />}
    </>
  )
}

const mapStateToProps = () => {
  return {}
}

export default connect(mapStateToProps, { setActualPage })(ConfirmationPage)
